var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBack = function SvgIconBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.79257143,10.2861558 L15.4451169,1.46958442 C15.7820779,1.13348052 15.7820779,0.588181818 15.4451169,0.252077922 C15.1081558,-0.084025974 14.5611429,-0.084025974 14.2241818,0.252077922 L3.9525974,9.63366234 C3.77254545,9.81285714 3.69623377,10.0512208 3.70823377,10.2852727 C3.69623377,10.5202078 3.77254545,10.7576883 3.9525974,10.9369091 L14.2241818,20.3184675 C14.5611429,20.6545714 15.1081558,20.6545714 15.4451169,20.3184675 C15.7820779,19.9823896 15.7820779,19.4370649 15.4451169,19.100987 L5.79257143,10.2861558 Z",
    id: "icon_back_path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_back_06.4---Usuarios---Lista-de-roles-&-Crear-rol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_back_03.4.1---Roles-list",
    transform: "translate(-95.000000, -274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_back_Info",
    transform: "translate(95.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_back_Icon",
    transform: "translate(0.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icon_back_Oval",
    className: "main-color",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_back_Icon-/-Back",
    transform: "translate(8.000000, 10.285714)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_back_mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_back_path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon_back_Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#icon_back_path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_back_Group",
    mask: "url(#icon_back_mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_back_Back-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon_back_Color",
    x: 0,
    y: 0,
    width: 20.5714286,
    height: 20.5714286
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_back.8dd14cd3.svg";
export { ForwardRef as ReactComponent };